export const STATE_NAME = 'experiments';
export const USER_IDENTIFIER_COOKIE_NAME = 'ha_anonymous_id';
